import { Injectable, Inject, Output } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/internal/operators/catchError';
import { throwError } from 'rxjs/internal/observable/throwError';
import {
    IAccounts,
    IContact,
    ICountry,
    ILaboratory,
    IRegion,
    ISpecies,
    ISubscriptionType
} from '../interfaces/accounts-interface';
import { DataList } from '../models/DataList';
import { isNullOrUndefined } from 'util';
import { Contact } from '../models/Contact';
import { firstValueFrom } from 'rxjs/internal/firstValueFrom';
import { Observable } from 'rxjs/internal/Observable';
import { PropertyEvent } from '../../models/EventSchedule';
import { Event } from '../../../shared-data/models/Event';
import { NavServiceService } from "src/app/shared/services/nav-service.service";
import {ActivatedRoute} from "@angular/router";
import {ObjectHolder} from "../../../../../../shared/models/objectHolder";
import {Site} from "../../models/Site";


@Injectable({
    providedIn: 'root'
})
export class ManagementStateService {

    myAppUrl = '';
    _data: any;

    constructor(public _http: HttpClient, @Inject('BASE_URL') baseUrl: string, private _navService: NavServiceService) {
        this.myAppUrl = baseUrl;
    }

    public async checkRouteIDs(route: ActivatedRoute) {
        var accountIDParam = route.snapshot.paramMap.get("accountId");
        var propertyIDParam = route.snapshot.paramMap.get("propertyId");

        if (parseInt(accountIDParam)) {
           await this.selectAccountById(parseInt(accountIDParam));
        }
        if (parseInt(propertyIDParam)) {
            await this.selectPropertyById(parseInt(propertyIDParam));
        }
    }

    public get getSelectedAccountName() {
        return this._navService.selectedAccounts.getSelectedAccountName;
    }

    public get getSelectedAccountId() {
        return this._navService.selectedAccounts.getSelectedAccountId;
    }

    private selectedAccountCanWhiteLabel: boolean = false;

    public get getSelectedAccountCanWhiteLabel() {
        return this.selectedAccountCanWhiteLabel;
    }

    public async setSelectedAccount(id: number, name: string) {
        this._navService.selectedAccounts.setSelectedAccount(id, name);
        this.selectedAccountCanWhiteLabel = await firstValueFrom(this.canAccountWhiteLabel());
        this._navService.updateNavCounts();
    }

    public clearSelectedAccount() {
        if (this._navService.selectedAccounts.getSelectedAccountId) {
            this._navService.selectedAccounts.clearSelectedAccount();
            this.selectedAccountCanWhiteLabel = false;
            this._navService.updateNavCounts();
        }
    }

    public get getSelectedPropertyId() {
        return this._navService.selectedAccounts.getSelectedPropertyId;
    }

    public get getSelectedPropertyName() {
        return this._navService.selectedAccounts.getSelectedPropertyName;
    }

    public setSelectedProperty(id: number, name: string) {
        this._navService.selectedAccounts.setSelectedProperty(id, name);
        this._navService.updateNavCounts();
    }

    public clearSelectedProperty() {
        if (this._navService.selectedAccounts.getSelectedPropertyId) {
            this._navService.selectedAccounts.clearSelectedProperty();
            this._navService.updateNavCounts();
        }
   }

    async selectAccountById(accountId: number) {
        var result = await firstValueFrom(this._http.post<any>(`api/AccountManagement/GetAccountNameById`, new ObjectHolder(accountId)).pipe(catchError(this.handleError)));
        if (result) {
            await this.setSelectedAccount(result.item1, result.item2);
        }
   }

    async selectPropertyById(propertyId: number) {
        var result = await firstValueFrom(this._http.post<any>(`api/AccountManagement/GetPropertyNameById`, {item1: propertyId, item2: this.getSelectedAccountId}).pipe(catchError(this.handleError)));
        if (result)
            await this.setSelectedProperty(result.item1, result.item2);
    }

    public canAccountWhiteLabel(): Observable<boolean> {
        return this._http
            .get<boolean>(this.myAppUrl + "api/AccountManagement/AccountCanWhiteLabel?accountID=" + this._navService.selectedAccounts.getSelectedAccountId)
            .pipe(
                catchError(this.handleError)
            );
    }

    private handleError(error: Response) {
        return throwError(error.statusText);
    }

}
